/*
 * Creates an object that represents the small format size of a given width
 * This should only be used when simulating small Format.
 * Actual small format styles should be applied using media queries.
 * Due to this. This will return nothing if actually in small format
 */

function SmallFormatSizingService(breakpointsService) {
    this.breakpointsService = breakpointsService;
}

SmallFormatSizingService.prototype.createResponsiveSizingObject = function (elementWidth) {
    const sizeObject = {};
    if (!this.breakpointsService.isInSmallFormat) {
        if (elementWidth >= this.breakpointsService._smallFormatBreakpointLg && elementWidth < this.breakpointsService._smallFormatBreakpoint) {
            sizeObject.large = true;
        } else if (elementWidth >= this.breakpointsService._smallFormatBreakpointMd && elementWidth < this.breakpointsService._smallFormatBreakpointLg) {
            sizeObject.medium = true;
        } else if (elementWidth >= this.breakpointsService._smallFormatBreakpointSm && elementWidth < this.breakpointsService._smallFormatBreakpointMd) {
            sizeObject.small = true;
        } else if (elementWidth < this.breakpointsService._smallFormatBreakpointSm) {
            sizeObject.xSmall = true;
        }
    }

    return sizeObject;
};

module.exports = SmallFormatSizingService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/small-format-sizing/small-format-sizing-service.js
 **/